import { configureDatadog } from '@storebrand-digital/common-datadog';
import type { Environment } from '@storebrand-digital/common-datadog/dist/environment';
import packageJson from '../../package.json';

function initDatadog() {
  configureDatadog({
    environment: window.env.DATADOG_ENVIRONMENT as Environment,
    clientPublicToken: 'pubcdd8eee3615d378cfd866b60d8674050',
    appId: 'c1c44639-2be5-4398-af65-e36566499fc1',
    appName: 'document-archive-web',
    appVersion: packageJson.version,
    configureLogging: true,
    forwardConsoleLogs: ['error'],
  });
}

export default initDatadog;
